import React from 'react';

export const BrityHeader = () => {
  return (
    <div className="brityworks">
      <div className="header">
        <a className="logo" href={window.location.origin}>
          brityworks
        </a>
      </div>
    </div>
  );
};
BrityHeader.propTypes = {};
BrityHeader.defaultProps = {};
export default BrityHeader;
